import gql from "graphql-tag";

export const GetApplicantDetails = gql`
  query GetApplicantDetails($id: String!, $opportunityId: String!) {
    accounts(id: $id) {
      id
      bio
      username
      name
      picture
      partneredBrands {
        id
        name
        picture
      }
      identities {
        connection
        userId
        isSocial
        profileUrl
        provider
      }
      applicationEvents(opportunityId: $opportunityId) {
        id
        createdAt
        status
        message
      }
      videos {
        id
        thumbnailUrl
        name
        owner {
          name
        }
        stats {
          totalSales
          totalViews
        }
      }
    }
  }
`;
